import maskRecipientFromFindControl from 'owa-readwrite-recipient-well/lib/actions/maskRecipientFromFindControl';
import FindRecipient from 'owa-recipient-common/lib/components/findrecipient';
import * as React from 'react';
var styles = require('./FindResultRecipient.scss');
var FindResultRecipient = function (props) {
    var itemProps = props.itemProps, viewState = props.viewState, persona = props.persona, onMaskRecipient = props.onMaskRecipient;
    return (React.createElement("div", { className: styles.selectedPeopleList },
        React.createElement(FindRecipient, { key: persona.EmailAddress.EmailAddress, findRecipient: persona, isHighlighted: itemProps.suggestionModel.item.isSelected, addRecipientAction: function () {
                /* no-op*/
            }, maskRecipientAction: maskRecipientAction(viewState, onMaskRecipient) })));
};
function maskRecipientAction(viewState, onMaskRecipient) {
    return function (recipientToMask) {
        maskRecipientFromFindControl(viewState, recipientToMask);
        onMaskRecipient(viewState);
    };
}
export default FindResultRecipient;
//# sourceMappingURL=FindResultRecipient.js.map